import apiRequest from './api-request';
import { ScrapedCompanyItem } from '../components/ScrapedCompanies/format';

export function getScrapedCompanies({
    acceptedOnly,
    failedOnly,
    hasChanges,
    page,
    orderBy,
    orderDirection
}: {
    acceptedOnly: boolean | null,
    failedOnly: boolean | null,
    hasChanges: boolean | null,
    page: number,
    orderBy?: string,
    orderDirection?: 'asc' | 'desc'
}) {
    const params = new URLSearchParams({
        page: String(page)
    });
    if (acceptedOnly != null) {
        params.set('acceptedOnly', String(acceptedOnly));
    }
    if (failedOnly != null) {
        params.set('failedOnly', String(failedOnly));
    }
    if (hasChanges != null) {
        params.set('hasChanges', String(hasChanges));
    }
    if (orderBy) {
        params.set('orderBy', orderBy);
    }
    if (orderDirection) {
        params.set('orderDirection', orderDirection);
    }
    return apiRequest({
        method: 'GET',
        resource: `scraped-companies?${params.toString()}`
    }) as Promise<{
        items: ScrapedCompanyItem[],
        total: number,
        page: number,
        pageSize: number
    }>;
}

export function getTenantScrapedCompany(tenantId: number | string) {
    return apiRequest({
        method: 'GET',
        resource: `tenants/${tenantId}/scraped-company`
    }) as Promise<{ item: ScrapedCompanyItem | null }>;
}

export function enqueueTenantScrape(tenantId: number | string) {
    return apiRequest({
        method: 'POST',
        resource: `tenants/${tenantId}/scrape`
    }) as Promise<{ status: 'pending' | 'alreadyPending' }>;
}

export function applyScrapedCompanies(body: {
    tenantIds: number[],
    scope: 'selected' | 'all',
    mode: 'overwrite' | 'unedited',
    acceptedOnly: boolean | null,
    failedOnly: boolean | null,
    hasChanges: boolean | null
}) {
    return apiRequest({
        method: 'POST',
        resource: 'scraped-companies/apply',
        body
    }) as Promise<{ updated: number, skipped: number, failed: number }>;
}
